var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6087 7.52167C22.5092 7.52167 23.2391 6.7917 23.2391 5.89123C23.2391 4.99077 22.5092 4.2608 21.6087 4.2608C20.7082 4.2608 19.9783 4.99077 19.9783 5.89123C19.9783 6.7917 20.7082 7.52167 21.6087 7.52167Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4534 14.1207L14.2958 11.963C14.0672 11.6944 13.7323 11.5397 13.3795 11.5397C13.0268 11.5397 12.6918 11.6944 12.4632 11.963C11.4578 12.9674 13.7676 16.8109 12.7589 17.8152C12.5189 18.0644 12.1879 18.2052 11.842 18.2052C11.4961 18.2052 11.1651 18.0644 10.9252 17.8152L8.76758 15.6576",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9164 12.5837L16.0696 11.4305",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15222 18.3477L10.3055 17.1945",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88483 14.2021C1.63844 14.4482 1.5 14.7822 1.5 15.1304C1.5 15.4786 1.63844 15.8126 1.88483 16.0587L11.4413 25.6152C11.6874 25.8616 12.0214 26 12.3696 26C12.7178 26 13.0518 25.8616 13.2979 25.6152L25.7315 13.1815C26.2236 12.6894 26.5 12.022 26.5 11.3261V2.08695C26.5 1.48665 26.0134 1 25.413 1H16.1739C15.478 0.999974 14.8106 1.2764 14.3185 1.76848L1.88483 14.2021Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingAlt);
export default __webpack_public_path__ + "static/media/billing-alt.ffdb8de567793149e23a2593f31d159e.svg";
export { ForwardRef as ReactComponent };